@if (isSectionVisible) {
  <section class="tw-font-lexend tw-flex tw-flex-col tw-bg-teal-100 tw-pl-4 tw-py-6">
    <div class="tw-flex tw-flex-col tw-gap-3">
      <div class="tw-flex tw-items-center tw-justify-between tw-pr-4" (click)="viewAll()">
        <div class="tw-flex tw-flex-col">
          <div class="tw-flex tw-items-center tw-gap-1">
            <p class="tw-font-bold tw-capitalize tw-text-gray-800 tw-text-[18px] tw-leading-[23.4px]"
               i18n="@@justForYou">Just for you</p>
            <img class="tw-w-4 tw-h-[18px] tw-object-cover tw-mix-blend-multiply" src="/assets/gifs/just-for-you-star.gif" alt="" />
          </div>
          <p class="tw-font-normal tw-text-gray-500 tw-text-[14px] tw-leading-[23.4px]"
             i18n="@@basedOnYourSkinProfile">Based on your skin &amp; hair profile</p>
        </div>
        <cs-icon class="tw-h-6 tw-w-6 tw-text-teal-600" [iconName]="'chevron_right'"></cs-icon>
      </div>

      <div class="tw-flex tw-items-start tw-gap-4 tw-overflow-x-auto hide-scrollbar">
        @for (product of products; track product.objectId) {
          <div class="tw-flex tw-flex-none tw-flex-col tw-gap-2 tw-w-[152px]">
            <div class="tw-w-[152px] tw-h-[190px] tw-bg-gray-100 tw-border-2 tw-border-solid tw-border-white tw-rounded-[10px] tw-overflow-hidden"
                 (click)="viewProduct(product)">
              <img #image="" class="tw-w-full tw-h-full tw-object-cover"
                   [src]="productImage(product)" alt="{{ product?.title }}" />
            </div>
            <div class="tw-flex tw-flex-col tw-gap-3 tw-w-full">
              <div class="tw-flex tw-flex-col tw-gap-1">
                <div class="tw-h-[18px] tw-flex tw-items-center">
                  @if (product.tag) {
                    <div class="tw-flex tw-items-center tw-gap-1 tw-h-[18px] tw-px-2 tw-rounded-xl tw-border-[0.5px] tw-border-solid tw-border-orange-500 tw-bg-recommended-tag">
                      <span class="tw-flex-none tw-w-1 tw-h-1 tw-rounded-full tw-bg-orange-500"></span>
                      <span class="tw-font-normal tw-text-[10px] tw-leading-[18px] tw-text-[#a93400] tw-whitespace-nowrap">{{ product.tag }}</span>
                    </div>
                  }
                </div>
                <div class="tw-flex tw-flex-col tw-gap-0.5">
                  <p class="tw-font-medium tw-text-[12px] tw-leading-[18px] tw-text-black tw-h-[36px] tw-line-clamp-2 tw-overflow-hidden"
                     (click)="viewProduct(product)">{{ product.title }}</p>
                  <div class="tw-flex tw-items-center tw-gap-1 tw-h-[21px]">
                    @if (hasDiscount(product)) {
                      <p class="tw-font-medium tw-text-[12px] tw-leading-[18px] tw-line-through tw-text-gray-500">₹{{ product.mrp }}</p>
                    }
                    <p class="tw-font-bold tw-text-[14px] tw-leading-[21px] tw-text-orange-500">₹{{ product.price }}</p>
                  </div>
                </div>
              </div>
              @if (isInCart(product)) {
                <div class="tw-flex tw-items-center tw-justify-between tw-w-20 tw-h-8 tw-px-2 tw-rounded-lg tw-border tw-border-solid tw-border-teal-600 tw-bg-white tw-text-teal-600">
                  <cs-icon class="tw-w-[9px] tw-h-5 tw-text-teal-600" [iconName]="'minus'"
                           (click)="updateCart(product, cartAction.REMOVE, $event, image)"></cs-icon>
                  <span class="tw-font-semibold tw-text-[14px] tw-leading-[21px]">{{ quantityInCart(product) }}</span>
                  <cs-icon class="tw-w-[9px] tw-h-5 tw-text-teal-600" [iconName]="'plus'"
                           (click)="updateCart(product, cartAction.ADD, $event, image)"></cs-icon>
                </div>
              } @else {
                <div class="tw-flex tw-items-center tw-justify-center tw-w-20 tw-h-8 tw-px-4 tw-py-2 tw-rounded-lg tw-bg-teal-600 tw-overflow-hidden"
                     (click)="updateCart(product, cartAction.ADD, $event, image)">
                  <span class="tw-font-semibold tw-text-[14px] tw-leading-[21px] tw-text-white" i18n="@@add">Add</span>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </section>
}
